// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import Help from "@keller/XDL/Icons/Help";
import { xBaseTheme } from "@keller/XDL/types";
import { color, getSystemColor, styledScrollbar } from "@keller/XDL/Utilities";
import { css } from "styled-components";

export default {
    defaultProps: {
        mergeCss: true,
        cssOverrides: {
            tooltipWrapper: css`
                line-height: 0;
            `,
            tooltipBody: css`
                display: flex;
                flex-direction: column;
                flex: 0 0 auto;
            `,
            tooltipClickable: css`
                margin-left: 5px;
                margin-right: 5px;
            `,
        },
        iconProps: {
            src: Help,
            size: 16,
            color: "secondary",
            css: css``,
        },
        typographyProps: {
            size: 12,
            lineHeight: "18px",
            css: css`
                letter-spacing: 0;
                &:hover {
                    text-decoration: none;
                }
            `,
        },
        extendedStyles: {
            tooltipContent: {
                css: css`
                    box-shadow: 0 2px 4px 0 ${color("common.ui8", 0.1)};
                    padding: 15px;
                    font-size: 13px;
                    font-weight: 400;
                    line-height: 18px;
                    max-width: 300px;
                    border: 1px solid ${color("common.ui5")};
                    border-radius: 6px;
                    background-color: ${color("common.white")};
                    min-width: 140px;
                    && {
                        overflow-y: visible;
                    }
                    ${styledScrollbar(2)}
                `,
            },
            tooltipArrow: {
                width: 30,
                height: 15,
                fill: getSystemColor("common.white"),
                stroke: `${getSystemColor("common.border")}`,
                strokeWidth: 1,
            },
        },
    },
} as xBaseTheme["tooltip"];
